/**
 * Tax-receipt completeness of a donor (OP-7954).
 *
 * OPDON refuses to record a donation whose donor lacks what the receipt needs. The creation modal
 * asks the same question up front so the user fixes the fiche instead of hitting a 400 on save.
 */
/**
 * Reads the gaps OPDON puts in the ProblemDetails `errorResult` when it refuses a write
 * (`Donation.Donor.ReceiptInformationMissing`). Same shape as the completeness endpoint's answer,
 * so the refusal can be shown with the very words the creation modal uses. Anything that is not
 * that shape yields an empty list, and the caller falls back to its generic message.
 */
export function parseDonorInformationGaps(errorResult) {
    if (errorResult === null || typeof errorResult !== "object" || !("gaps" in errorResult)) {
        return [];
    }
    const gaps = errorResult.gaps;
    if (!Array.isArray(gaps))
        return [];
    return gaps.filter((gap) => gap !== null &&
        typeof gap === "object" &&
        typeof gap.scope === "string" &&
        Array.isArray(gap.fields));
}
/**
 * Renders one gap as "<object> : <fields>", with the SAME keys the notice uses. Shared so the three
 * surfaces that can show a refusal — the two create modals and the donation detail view — describe
 * it identically; three private copies had already started to drift.
 */
export function describeDonorInformationGap(gap, t) {
    const scope = t(`finance.donations.create.receiptInformation.scope.${gap.scope}`);
    const fields = gap.fields
        .map((field) => t(`finance.donations.create.receiptInformation.fields.${field}`))
        .join(", ");
    return `${scope} : ${fields}`;
}
